import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  deepLoadScenarioPreprogrammeAction,
  deepLoadScenarioPreprogrammeActionSuccessAction,
  loadScenarioPreprogrammesAction,
  loadScenarioPreprogrammesSuccessAction,
  ScenarioPreprogrammeState,
  selectIsScenarioPreprogrammeInitialized,
} from './scenario-preprogramme.store';
import { SpService } from '../../_services/http/sp.service';
import { Update } from '@ngrx/entity';
import { IScenarioPreprogramme } from '../../_models/ScenarioPreprogramme';

@Injectable()
export class ScenarioPreprogrammeEffect {
  constructor(
    private service: SpService,
    private actions$: Actions,
    private store: Store<ScenarioPreprogrammeState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadScenarioPreprogrammesAction),
      withLatestFrom(
        this.store.select(selectIsScenarioPreprogrammeInitialized)
      ),
      filter(([action, isInitialized]) => !isInitialized),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadScenarioPreprogrammesSuccessAction({ payload })),
          catchError(() => EMPTY)
        )
      )
    )
  );

  deepLoad$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deepLoadScenarioPreprogrammeAction),
      mergeMap((action) =>
        this.service.retrieve(action.id).pipe(
          map((item) => {
            if (item) {
              // @ts-ignore
              const payload: Update<IScenarioPreprogramme> = {
                id: item.id,
                changes: {
                  features: item.features,
                  etapes: item.etapes.sort((a, b) => {
                    if (a.ordre > b.ordre) {
                      return 1;
                    }
                    return -1;
                  }),
                },
              };
              return deepLoadScenarioPreprogrammeActionSuccessAction({
                payload,
              });
            }

            return deepLoadScenarioPreprogrammeActionSuccessAction({
              payload: undefined,
            });
          }),
          catchError(() => EMPTY)
        )
      )
    )
  );
}
